import api from './api';

const RankingService = {
  get: () => api.get('rankings'),
};

export default RankingService;
